import React, { useState } from 'react'

import { FaFileExcel, FaPlus } from 'react-icons/fa'
import { IconContext } from 'react-icons'

import { columnsToTemplate } from '../../../../../_helpers/SpreadSheetUtils'
import { createInvoiceForSchedule } from '../../../../../_services/lender.service'
import { getDateInputFormat, systemNow } from '../../../../../_helpers'
import { tableFormat } from '../../../../../_helpers/invoices'

import { Button } from '../../../../../_components/Button'
import { LoaderButton } from '../../../../../_components/LoaderButton'
import { UploadInvoicesButton } from './UploadInvoicesButton'

import { S_InvoicesOverview_TableControls } from '../../../../ClientViews/UploadInvoices/S_UploadInvoices'

export const EditScheduleTableControls = ({
  refreshInvoicesTable,
  columns,
  business,
  lastDebtor,
  scheduleId,
  addNewInvoice,
  reloadSchedulePage,
  setLoading,
  isLoading,
  disabled,
  setTotalInvoices,
}) => {
  const [addingNewInvoice, setAddingNewInvoice] = useState(false)

  const addInvoice = async () => {
    setAddingNewInvoice(true)
    const defaultDebtorDueDate = systemNow()
    defaultDebtorDueDate.setDate(defaultDebtorDueDate.getDate() + 30)
    let saveInvoice = {
      business_id: business.id,
      invoice_date: getDateInputFormat(systemNow()),
      debtor_due_date: getDateInputFormat(defaultDebtorDueDate),
      payment_terms: 90,
      face_value: 0,
    }
    if (lastDebtor) {
      saveInvoice.debtor_id = lastDebtor
    }

    await createInvoiceForSchedule({
      invoice: saveInvoice,
      invoice_schedule_id: scheduleId,
    }).then((newInvoice) => {
      addNewInvoice(tableFormat(newInvoice))
      setAddingNewInvoice(false)
    })
  }

  // Upload

  return (
    <S_InvoicesOverview_TableControls>
      <Button
        className={`table-controls-btn compact`}
        onClick={() => {
          columnsToTemplate(
            columns.map((c) => {
              c.headingText = c.label
              return c
            })
          )
        }}
      >
        <IconContext.Provider value={{ size: '16px', className: 'add-icon' }}>
          <FaFileExcel />
        </IconContext.Provider>
        Need Template?
      </Button>

      <UploadInvoicesButton
        disabled={disabled}
        isLoading={isLoading}
        refreshInvoicesTable={refreshInvoicesTable}
        reloadSchedulePage={reloadSchedulePage}
        scheduleId={scheduleId}
        setLoading={setLoading}
        setTotalInvoices={setTotalInvoices}
      />
      <LoaderButton
        className={`table-controls-btn compact`}
        disabled={disabled}
        icon="add"
        isLoading={isLoading || addingNewInvoice}
        onClick={() => addInvoice()}
      >
        <IconContext.Provider value={{ size: '16px', className: 'add-icon' }}>
          <FaPlus />
          {`New Invoice`}
        </IconContext.Provider>
      </LoaderButton>
    </S_InvoicesOverview_TableControls>
  )
}
